import type { TFunction } from "i18next";
import U2000SaveCancelDialog from "../../../../../u2000Core/components/dialog/U2000SaveCancelDialog";
import U2000ComboBoxBase from "../../../../../u2000Core/components/formControls/combobox/U2000ComboBoxBase";
import { U2000FormStateEnumEditMode } from "../../../../../u2000Core/reducer/formReducer/U2000FormState";
import { type U3148AffiliationActionHandler } from "./U3148AffiliationActionHandlers";
import type { U3148LogicalUnit, U3148LogicalUnitAction } from "../../../../U3148Service";

// Typage des props du composant
interface U3148AffiliationActionDlgProps {
  u3148AffiliationActionHandler: U3148AffiliationActionHandler;
  t: TFunction;
  NS: string;
}

// Composant pour le dialogue d'édition des actions d'une unité logique
function U3148AffiliationActionEditDlg({ u3148AffiliationActionHandler, t, NS }: U3148AffiliationActionDlgProps) {
  const { formStateHandlers } = u3148AffiliationActionHandler;

  // Unified handler that manages Save and Cancel differently
  const handleClose = (action: "save" | "cancel") => {
    if (action === "cancel") {
      // Temporarily disable onBlur validation to prevent unwanted validation on cancel
      const originalOnBlur = formStateHandlers.onBlur;
      formStateHandlers.onBlur = () => {
        /* Ignore onBlur during cancel */
      };

      // Close dialog immediately without validation
      u3148AffiliationActionHandler.onDlgClose("cancel");

      // Restore original onBlur handler after dialog closes
      setTimeout(() => {
        formStateHandlers.onBlur = originalOnBlur;
      }, 0);
    } else if (action === "save") {
      // Normal save flow with validation
      u3148AffiliationActionHandler.onDlgClose("save");
    }
  };

  const filteredLogicalUnitActions = u3148AffiliationActionHandler.logicalUnits.filter(
    (lu) => !u3148AffiliationActionHandler.gridLogicalUnitCodes.includes(lu.logicalUnitCode) || (formStateHandlers.getData() && lu.logicalUnitCode === formStateHandlers.getData().logicalUnitCode)
  );

  // renmder
  return (
    <U2000SaveCancelDialog
      width="w-[700px]"
      height="h-[700px]"
      isOpen={u3148AffiliationActionHandler.isDialogOpen}
      onClose={handleClose}
      title={t("user.lblLogicalUnitAction", { ns: NS })}
      isValid={true}
    >
      <div className="flex flex-col gap-y-4">
        <U2000ComboBoxBase<U3148LogicalUnit>
          data={filteredLogicalUnitActions}
          keyField="id"
          descField="logicalUnitDescription"
          onChangeObject={u3148AffiliationActionHandler.onLogicalUnitChangeObject}
          value={u3148AffiliationActionHandler.formStateHandlers.getData() as U3148LogicalUnit}
          disabled={u3148AffiliationActionHandler.formStateHandlers.getFormEditMode() === U2000FormStateEnumEditMode.EDIT}
        />

        {u3148AffiliationActionHandler.logicalUnitActions &&
          u3148AffiliationActionHandler.logicalUnitActions.map((action: U3148LogicalUnitAction, index) => (
            <div key={index} className="mb-1 flex items-center gap-x-2">
              <div
                className={`h-6 w-6 cursor-pointer rounded-sm border-2 transition-colors duration-300 ${action.idChecked ? "border-blue-500 bg-blue-100" : "border-gray-300 bg-white"}`}
                onClick={() => u3148AffiliationActionHandler.onCheckLogicalUnitAction(action)}
              >
                {action.idChecked && (
                  <svg className="m-auto h-5 w-5 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
              <p className="inline-block text-gray-800">
                {action.logicalUnitActionCode} - {action.logicalUnitActionDescription}
              </p>
            </div>
          ))}
      </div>
    </U2000SaveCancelDialog>
  );
}

export default U3148AffiliationActionEditDlg;
